// extracted by mini-css-extract-plugin
export var form = "_dt-0";